// Display only. Shopify's publication schedule is the purchase gate.
export function releaseCountdown(launch, now = Date.now()) {
  const deadline = Date.parse(launch);
  if (!Number.isFinite(deadline)) return { valid: false, ready: false, text: '' };
  const remaining = Math.max(0, deadline - now);
  const minutes = Math.ceil(remaining / 60000);
  const days = Math.floor(minutes / 1440);
  const hours = Math.floor((minutes % 1440) / 60);
  const mins = minutes % 60;
  return { valid: true, ready: remaining === 0, text: `${days}d ${hours}h ${mins}m` };
}

if (typeof customElements !== 'undefined' && !customElements.get('bhc-launch-countdown')) {
  customElements.define('bhc-launch-countdown', class extends HTMLElement {
    connectedCallback() {
      this.controller = new AbortController();
      this.update = this.update.bind(this);
      document.addEventListener('visibilitychange', this.update, { signal: this.controller.signal });
      this.update();
    }
    update() {
      clearTimeout(this.timer);
      const result = releaseCountdown(this.dataset.launch);
      const counter = this.querySelector('[data-countdown]');
      if (!result.valid) return;
      if (result.ready) {
        // Re-fetch Liquid and Shopify availability; never reveal a hidden purchase form.
        if (this.waiting && this.dataset.refreshAtLaunch === 'true' && !window.Shopify?.designMode) {
          window.location.reload();
        } else {
          this.textContent = 'Opening soon';
        }
        return;
      }
      this.waiting = true;
      if (counter) counter.textContent = ` · ${result.text}`;
      this.timer = setTimeout(this.update, Math.min(Date.parse(this.dataset.launch) - Date.now() + 20, 60000));
    }
    disconnectedCallback() {
      clearTimeout(this.timer);
      this.controller?.abort();
    }
  });
}
